import React from 'react'
import styles from './styles.module.scss'
import { useStatsJoueursDataContext } from '../../../contexts/StatsJoueursDataContext'
import { JoueurType } from '../data'

const BUT_OU_ARRET_HEADER: { [x in JoueurType]: string } = {
    joueur_de_champ: 'But',
    gardien: 'Arrêt',
}

export const Header = () => {
    const { isDesktop, joueurType } = useStatsJoueursDataContext()

    return (
        <div className={styles.header}>
            <div className={styles.rank}>{isDesktop ? 'Position' : 'Pos.'}</div>
            <div className={styles.name}>Joueur</div>
            <div className={styles.club}>Club</div>
            <div className={styles.num1}>{BUT_OU_ARRET_HEADER[joueurType]}</div>
            <div className={styles.num2}>{isDesktop ? 'Match' : 'Mat.'}</div>
            <div className={styles.num3}>Moy.</div>
            <div className={styles.toggle} />
        </div>
    )
}
